export function addSuperTokenInfoToPaymentOptions(paymentOptions, getSuperToken, getUnderlyingToken, getNativeAsset) {
    return paymentOptions
        .map((paymentOption) => {
        const superToken = getSuperToken(paymentOption.superToken.address);
        const underlyingToken = superToken.extensions.superTokenInfo.type === "Wrapper"
            ? getUnderlyingToken(superToken.extensions.superTokenInfo.underlyingTokenAddress)
            : superToken.extensions.superTokenInfo.type === "Native Asset"
                ? getNativeAsset(paymentOption.chainId)
                : null;
        return {
            paymentOption,
            superToken,
            underlyingToken,
        };
    })
        .filter((x) => x !== null);
}
